import { CreativeType } from 'core/creative/Creative';
import { ImageCreativeListDataProvider } from './ImageCreativeListDataProvider';
import { ProductNativeCreativeListDataProvider } from './ProductNativeListDataProvider';
import { RichProductNativeCreativeListDataProvider } from './RichProductNativeListDataProvider';

export function getDataProvider (creativeType: CreativeType, model: any) {

  switch (creativeType) {
    case CreativeType.IMAGE:
      return new ImageCreativeListDataProvider(model);
    case CreativeType.PRODUCT_NATIVE:
    case CreativeType.SITE_WIDE_RECOMMENDED:
    case CreativeType.PERSONALIZED_GOLDEN_RECOMMENDED:
      return new ProductNativeCreativeListDataProvider(model);
    case CreativeType.RICH_PRODUCT_NATIVE:
    case CreativeType.WEB_RICH_PRODUCT_NATIVE:
    case CreativeType.BRAND_LED:
      return new RichProductNativeCreativeListDataProvider(model);
    default:
      return new ImageCreativeListDataProvider(model);
  }
}
